const config = {
    API_URL: 'https://api.web.mazingday.com',
    facebook: 'https://www.facebook.com/mazingday',
    linkedin: 'https://www.linkedin.com/company/mazingday',
    instagram: 'https://www.instagram.com/mazingdayofficial/',
    tiktok: 'https://www.tiktok.com/@mazingdayofficial'
};
export default config;